export const API_KEY_PROVIDER_COGNIFLOW = 0;
export const API_KEY_PROVIDER_OPENAI = 1;
